<template>
  <div class="manage" @click="outFiltrate">
    <div class="main_box">
      <template>
        <el-tabs v-model="activeName" @tab-click="handleClick">

          <el-tab-pane v-if="interpreterFun()" :label="interpreterlabel()" name="interpreter">
            <interpreter v-if="activeName==='interpreter'"></interpreter>
          </el-tab-pane>

          <el-tab-pane v-if="proofreadingFlagFun()" :label="proofreadingLabel()" name="proofreading">
            <proofreading v-if="activeName==='proofreading'"></proofreading>
          </el-tab-pane>

          <el-tab-pane v-if="reviewFlagFun()" :label="reviewFlagLabel()" name="review">
            <review v-if="activeName==='review'"> </review>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
  </div>
</template>

<script>
import interpreter from "@/common/designated_tasks/appoint_interpreter";
import proofreading from "@/common/designated_tasks/appoint_proofreading";
import review from "@/common/designated_tasks/appoint_review";

export default {
  name: "assignInterpreter",
  data () {
    return {
      activeName: "interpreter",
      flag: true,// 高校版不显示
      row: {},// 文件对象
    };
  },
  components: {
    interpreter,
    proofreading,
    review
  },
  computed: {

  },
  created () {
    if (process.env.VUE_APP_NAME == "school") {
      this.flag = true
    } else {
      this.flag = true
    }
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    this.row = this.queryData.row // taskType 1 重新指定译员， 2 重新指定审校
    if (this.interpreterFun()) {
      this.activeName = "interpreter"
    } else if (this.proofreadingFlagFun()) {
      this.activeName = "proofreading"
    } else if (this.reviewFlagFun()) {
      this.activeName = "review"
    }

  },
  methods: {
    //显示翻译
    interpreterFun () {
    console.log(this.queryData,"this.queryData");
      // this.queryData.level 从哪个级别跳进来的  0 文件   1  任务
      if (this.queryData.level === 0) {
        if ((this.row.taskCount === 1 && this.row.projectProcessType == 1) || this.row.transModel==1) {
          return true
        } else {
          return this.row.isTranslateSplit !== 1 ? true : false
        }
      } else {
        return this.queryData.type == 1 ? true : false
      }

    },
    //显示审校
    proofreadingFlagFun () {
      if (!this.flag) {
        return false
      } else {
        if (this.queryData.level === 0) {
          return this.row.projectProcessType !== 1 && this.row.isReviserSplit !== 1 ? true : false
        } else {
          return this.queryData.type == 2 ? true : false
        }
      }
    },
    //显示复审
    reviewFlagFun () {
      if (!this.flag) {
        return false
      } else {
        if (this.queryData.level === 0) {
          return this.row.projectProcessType == 3 && this.row.isSecondReviserSplit !== 1 ? true : false
        } else {
          return this.queryData.type == 3 ? true : false
        }
      }

    },
    // 审校显示label
    proofreadingLabel () {

      if (this.queryData.level === 1) {
        return "重新指定审校"
      } else {
        return "指定审校"
      }
    },
    interpreterlabel () {
      if (this.row.projectProcessType == 1 && this.row.isTranslateSplit == 1) {
        return this.row.transModel==1 ? "分配作业" : "重新指定译员"  // transModel 0 生产模式 1 作业模式
      } else {
        if (this.queryData.level === 1) {
          return this.row.transModel==1 ? "分配作业" : "重新指定译员"
        } else {
          return this.row.transModel==1 ? "分配作业" : "指定译员"
        }
      }

    },
    reviewFlagLabel () {
      if (this.queryData.level === 1) {
        return "重新指定复审"
      } else {
        return "指定复审"
      }
    },
    // 关闭筛选
    outFiltrate () {
      if (this.visible) {
        this.visible = false;
        this.iconCaret = "el-icon-caret-bottom";
        // this.currentPage = 1;
        // sessionStorage.setItem("myCurrentPage", 1);
        this.getSelfUserList(this.search_mod);
      }
    },
    handleClick (tab, event) {
      if (tab.name == "information") {
      }
    },
  }
};
</script>
<style lang="less" scoped>
.manage {
  /deep/.el-tabs__nav-wrap::after {
    background: white;
  }
  height: calc(100% - 14px);
  /*兼容IE*/
    @media screen and(-ms-high-contrast:active),(-ms-high-contrast:none){
        .main_box {
            height: calc(100% - 48px);
            position: relative;
            // height: 742px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            margin-top: 20px;
            // margin-top: 62px;
            padding: 20px;
        }
    }
  .main_box {
    .el-tabs {
      height: 100%;
      /deep/.el-tabs__content {
        height: 100%;
      }
      /deep/#pane-interpreter {
        height: 100%;
      }
      /deep/#pane-proofreading {
        height: 100%;
      }
      /deep/#pane-review {
        height: 100%;
      }
    }

    height: calc(100% - 48px);
    position: relative;
    // height: 742px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-top: 20px;
    // margin-top: 62px;
    padding: 20px;
    header {
      position: relative;
      height: 36px;
      .sortFiltrate {
        float: right;
        width: 100px;
        height: 36px;
        background: white;
        border: 0px;
        line-height: 0px;
        color: black;
      }
      h3 {
        float: left;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(69, 69, 69, 1);
        line-height: 36px;
      }
      .search {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
      }
      input {
        float: right;
        width: 260px;
        height: 34px;
        line-height: 36px;
        border: 1px solid rgba(184, 196, 206, 1);
        border-radius: 2px;
        padding: 0 10px;
      }
    }
    .btn {
      position: absolute;
      // bottom: 20px;
      left: 50%;
      transform: translate(-50%, 0);
      button {
        width: 90px;
        height: 36px;
        background: #454545;
        border: 1px solid rgba(69, 69, 69, 1);
        box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
        border-radius: 4px;
        color: rgba(255, 255, 255, 1);
        margin: 30px;
      }
      button:hover {
        background: #3e3e3e;
      }
      button:active {
        background: #333333;
      }
      button:nth-child(1) {
        color: #454545;
        background: rgba(228, 228, 228, 1);
        border: 1px solid rgba(69, 69, 69, 1);
      }
      button:nth-child(1):hover {
        background: #cdcdcd;
        border: 1px solid #3e3e3e;
      }
      button:nth-child(1):active {
        background: #bcbcbc;
        border: 1px solid #333333;
      }
    }
    // 表格样式开始
    /deep/.el-table {
      .el-table__empty-block {
        // 修改无数据 出现滚动条
        height: 90% !important;
      }
    }
    .el-table {
      margin: 10px auto;
      height: calc(97% - 100px);
      overflow: auto;
      .el-date-editor.el-input {
        // 截止时间
        width: 117px;
      }
      /deep/.el-input__icon {
        line-height: 24px;
      }
      /deep/.el-input__inner {
        width: 140px;
        border: none;
        // border-bottom: 2px solid #999999;
        height: 26px;
        line-height: 24px;
        // text-align: center;
      }
      /deep/.el-date-editor--time-select {
        input {
          width: 100px;
          padding-right: 0px;
        }
      }
      input {
        width: 54px;
      }
      /deep/.row-expand-cover .el-table__expand-icon {
        visibility: hidden;
      }

      /deep/th {
        text-align: center;
      }
      /deep/.el-table__expanded-cell {
        padding: 0;
        padding-left: 20px;
        border-bottom: 0px;
      }
      /deep/.el-table__expanded-cell:hover {
        background: #fff !important;
      }
    }
    /deep/.el-table::before {
      height: 0px;
    }
    /deep/.el-input-number__increase {
      height: 13px !important;
    }
    /deep/.el-table th.is-leaf {
      border-bottom: 0px;
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr {
      // background: rgba(241, 241, 241, 1);
      // margin-bottom: 30px;
      position: relative;
    }
    /deep/.el-table tbody tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5) !important;
      z-index: 1000;
      .operation {
        display: block;
        height: 23px;
      }
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }

    // /deep/.el-table td,
    //   .el-table th {
    //     // 修改table行高
    //     padding: 11px 0px !important;
    //   //   height: 36px !important;
    //     font-size: 12px;
    //   }
    /deep/.el-table td {
      border-bottom: 0px solid #ffff;
      text-align: center;
      font-size: 12px;
    }
    /deep/.el-table__body-wrapper {
      height: calc(100% - 50px);
      overflow-y: auto;
    }

    //   /deep/.el-table td:nth-child(2) {
    //     // text-align: left;
    //     .cell {
    //       overflow: hidden;
    //       text-overflow: ellipsis;
    //       white-space: nowrap;
    //     }
    //   }
    //   /deep/.el-table .el-table .el-table  td:nth-child(2) {
    //     text-align: center;
    //   }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }
    #notDate {
      // 暂无数据
      // margin-top: 80px;
      height: 100%;
      img {
        height: 50%;
        width: 50%;
      }
    }
    // 表格样式结束
  }
}
/deep/.el-select .el-input {
  // 修改筛选select
  width: 100%;
}
</style>
<style lang="less">
.manage {
  .main_box {
    // width: calc(100vw - 290px);
    .el-table__body {
      border-collapse: separate !important;
      border-spacing: 0px 2px !important;
    }
  }
}
</style>
